import GroupIcon from "../../assets/icons/Group.svg";
import { AiOutlineInfoCircle } from 'react-icons/ai';

const LandLoadPropertyCard = ({
  title = "Lakeside Villas",
  location = {city: "City 1", area: "Area 1"},
  occupied = 7,
  vacant = 5,
  totalUnits = 12,
  expectedRent = "UGX 4,500,000",
  rentCollected = 10,
  rentCollectedThisMonth = "UGX 1,200,000",
  onViewUnits
}) => {
  return (
    <div
      className="
        w-full
        max-w-[90vw]
        max-h-[310px]
        sm:max-w-[352px]
        mx-auto
        sm:w-[21.8125rem]
        xs:w-full
        rounded-lg overflow-hidden shadow-md bg-white border border-gray-200 flex flex-col
      "
    >
      {/* Title and Location */}
      <div className="px-6 py-4 flex justify-between items-start">
        <div className="min-w-[7.5rem]">
          <h1
            className="text-[1rem] font-medium font-sans truncate"
            style={{ color: "var(--primary-dark-blue-color)" }}
          >
            {title}
          </h1>
          <p className="text-[.75rem] font-inter font-medium text-gray-medium truncate">
            {location}
          </p>
        </div>

        {/* Occupied/Vacant Badges */}
        <div className="flex flex-row sm:flex-row gap-2">
          <div className="min-w-[4.6875rem] px-2 py-1 bg-[#4d76e326] rounded-[.625rem] flex flex-col items-center">
            <span className="text-custom-blue text-[.75rem] font-medium">Occupied</span>
            <span className="text-custom-blue text-[.75rem] font-bold">{occupied}</span>
          </div>
          {vacant !== undefined && (
            <div className="min-w-[4.6875rem] px-2 py-1 bg-[#45B89E26] rounded-[10px] flex flex-col items-center">
              <span className="text-custom-green text-[.75rem] font-medium">Vacant</span>
              <span className="text-custom-green text-[.75rem] font-bold">{vacant}</span>
            </div>
          )}
        </div>
      </div>

      {/* Stats Section */}
      <div className="px-6 space-y-3 mb-[46px]">
        <div
          className="flex justify-between items-center p-3 bg-white rounded-[10px]"
          style={{ boxShadow: '0 0 4px rgba(172,172,172,0.25)' }}
        >
          <div>
            <p className="text-[.75rem] font-normal text-[#707070] font-inter">Total Units</p>
            <p className="text-[.875rem] font-medium text-[#071952] font-inter">{totalUnits}</p>
          </div>
          <div className="text-right">
            <p className="text-[.75rem] font-normal text-[#707070] font-inter">Expected Rent</p>
            <p className="text-[.875rem] font-medium text-[#071952] font-inter">{expectedRent}</p>
          </div>
        </div>

        <div
          className="flex justify-between items-center p-3 bg-white rounded-[10px] xs:gap-x-4"
          style={{ boxShadow: '0 0 4px rgba(172,172,172,0.25)' }}
        >
          <div>
            <div className="flex items-center gap-1">
              <p className="text-[.75rem] font-normal text-[#707070] font-inter">Total Rent Collected</p>
              <div className="relative group items-center">
                <AiOutlineInfoCircle
                  size={12}
                  className="cursor-help text-[#707070]"
                />
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-[#000000] text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-[200px] text-center z-10">
                  Cumulative rent collected for this property across all time.
                </div>
              </div>
            </div>
            <p className="text-[.875rem] font-medium text-[#071952] font-inter">{Number(rentCollected).toFixed(2)}</p>
          </div>
          <div className="text-right">
            <div className="flex items-center justify-end gap-1">
              <div className="relative group items-center ">
                <AiOutlineInfoCircle
                  size={12}
                  className="cursor-help text-[#707070]"
                />
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-[#000000] text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-[200px] text-center z-10">
                  Amount calculated for the current month based on daily rent.
                </div>
              </div>
              <p className="text-[.75rem] font-normal text-[#707070] font-inter">This Month</p>
            </div>
            <p className="text-[.875rem] font-medium text-[#071952] font-inter">{Number(rentCollectedThisMonth).toFixed(2)}</p>
          </div>
        </div>
      </div>

      {/* Action Buttons with 46px space above */}
      <div className="px-4 pb-4 mt-auto flex gap-2">
        <button
          onClick={onViewUnits} // Use onViewUnits in the button click handler
          className="flex-1 flex justify-center items-center gap-1 text-[.75rem] rounded-[.9375rem] border py-1.5"
          style={{ color: '#2EA83C', borderColor: '#07C01D' }}
        >
          <img src={GroupIcon} alt="Group icon" width={14} height={14} />
          View Unit
        </button>
      {/*  <button
          className="flex-1 flex justify-center items-center gap-1 text-[.75rem] rounded-[.9375rem] border py-1.5"
          style={{ color: '#57209D', borderColor: '#57209D' }}
        >
          <img src={EditIcon} alt="Edit Icon" width={14} height={14} />
          Edit
        </button>
        <button
          className="flex-1 flex justify-center items-center gap-1 text-[.75rem] rounded-[.9375rem] border py-1.5"
          style={{ color: '#FF0202', borderColor: '#FF0505' }}
        >
          <img src={DeleteIcon} alt="Delete Icon" width={14} height={14} />
          Delete
        </button>*/}
      </div>
    </div>
  );
};

export default LandLoadPropertyCard;